import {Component, Inject, OnInit} from '@angular/core';
import {Delegation} from "./types/delegation";
import {DOCUMENT} from "@angular/common";

declare const window: Window;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  delegations: Delegation[];
  i18n: Map<string, string>;
  lang: string;
  selectedProvinces: string[];
  availableDelegations: Delegation[];

  constructor(@Inject(DOCUMENT) document) {}

  ngOnInit(): void {
    const delegationsPage = window["delegationsPage"];
    this.delegations = delegationsPage.delegations;
    this.i18n = delegationsPage.i18n;
    this.lang = delegationsPage.lang;
  }

  // Gets the value from the event target data-value attribute and shows the available delegations for the given
  // province, as well as highlighting the provinces for the delegations on the map.
  public selectDelegationsByProvince(event: any) {
    const selectedProvince = event?.target?.getAttribute("data-value") || "";
    const dropDownMenuButton = document.getElementById("dropdownMenuButton");
    let selectedProvinceName = event?.target?.getAttribute("data-name");

    if (selectedProvinceName) {
      dropDownMenuButton.innerText = selectedProvinceName;
    } else {
      selectedProvinceName = document.getElementById("dropdown-" + selectedProvince).getAttribute("data-name");

      dropDownMenuButton.innerText = selectedProvinceName || "";
    }

    this.availableDelegations = this.delegations.filter((delegation) => {
      return delegation.provinces.some(province => province.field === selectedProvince);
    });

    this.selectedProvinces = [];

    this.availableDelegations.forEach((delegation) => {
      this.selectedProvinces = this.selectedProvinces.concat(delegation.provinces.map((province) => province.field));
    });

    this.highlightSelectedProvincesOnMap();
  }

  // Removes the selected class from every province in the map
  removeSelectedFromProvinces() {
    const mapProvinces = document.getElementsByClassName("office__map__province");

    Array.prototype.forEach.call(mapProvinces, (province) => {
      if (province) {
        province.classList.remove("selected");
      }
    });
  }

  // Sets the selected class to the elements that matches the selected provinces
  highlightSelectedProvincesOnMap() {
    this.removeSelectedFromProvinces();

    for (const province of this.selectedProvinces) {
      const el = document.getElementById(province);

      try {
        el.classList.add("selected");
      } catch (e) {
        // just continue with the next one.
      }
    }
  }
}
